<div class="app-footer">
  <div class="app-footer__inner text-center center">
    <div class="text-muted" style="margin: auto;">
      Potenciado por Felipe Sotomayor
    </div>
  </div>
</div>
